import React from 'react';
import { Grid2 as Grid, type Grid2Props } from '@mui/material';
import { useFormContext } from 'framework/form';
import { getVisibility } from 'framework/utils';
import { SxProps } from '@mui/system';

export interface FormRowProps extends Grid2Props {
  children: React.ReactNode;
  colMd?: number;
  colXl?: number;
  customSxChild?: {
    [key: string | number]: SxProps;
  };
}

const FormRow = ({ children, colMd = 6, colXl = 3, customSxChild, sx, columns = 12, ...props }: FormRowProps) => {
  const { data: formData } = useFormContext();

  const visibleChildren = React.Children.toArray(children).filter(child => {
    if (!child || !React.isValidElement(child)) return false;
    return getVisibility(formData, child.props.isVisible);
  });

  return (
    <Grid container spacing={2} columns={columns} sx={{ alignItems: 'flex-start', width: '100%', ...sx }} {...props}>
      {visibleChildren.map((child, index) => {
        if (!React.isValidElement(child)) return null;

        return (
          <Grid
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            size={{ xs: 12, md: colMd, xl: colXl }}
            sx={customSxChild?.[index] || {}}
          >
            {child}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default FormRow;
